import React, { useEffect } from 'react'
import OrdersSectionTabs from 'orders/sectionTabs'
import { resetState } from './redux'
import { FeatureProps, withFeatures } from 'features'
import OrdersTable from './ordersTable'
import OrderFilters from './filters/searchAndDate'
import { useDispatch } from 'react-redux'
import OrderTableEventHandler from './orderTableEventHandler'
import { useHistory } from 'react-router-dom'
import BaseKnowledgeLink from 'uiComponents/typography/BaseKnowledgeLink'
import './index.css'
import { getHashParam, getHashRoute, removeHash } from 'utils/hash'
import MembershipDetailsPanel from 'memberships/membershipDetailsPanel/membershipDetailsPanel'

interface OrdersProps extends FeatureProps {
    children?: React.ReactNode
}

const Orders: React.FC<OrdersProps> = ({ children }) => {
    const history = useHistory()
    const dispatch = useDispatch()
    const selectedMembershipUuid = getHashParam('membershipUuid')
    const showMembershipDetailsPanel = getHashRoute() === 'membership_details' && selectedMembershipUuid

    useEffect(() => {
        return () => {
            dispatch(resetState())
            history.replace({ search: '' })
        }
    }, [])

    return (
        <div id="orders__elem">
            <OrdersSectionTabs />
            <OrderTableEventHandler>
                <OrderFilters />
                <OrdersTable />
            </OrderTableEventHandler>
            {children}
            <BaseKnowledgeLink link="https://support.convious.com/help/how-to-manage-orders" />
            {showMembershipDetailsPanel && (
                <MembershipDetailsPanel membershipUuid={selectedMembershipUuid} onClose={removeHash} />
            )}
        </div>
    )
}

export default withFeatures(Orders)
